module.exports = __webpack_public_path__ + "static/media/fees collection.b91492b0.svg";